<div class="rate shadow-small">
    @if (!finishedRating) {
    <h3>{{ lang.data["guide_feedback.title"] }}</h3>
    } @if (!finishedRating) {
    <div [innerHTML]="lang.data['guide_feedback.description']"></div>
    } @if (!showFeedback) {
    <div class="rate-actions">
        <div
            class="rate-negative rate-action pointer shadow-small"
            (click)="rateGuide('negative')"
        >
            <i class="fa fa-thumbs-down"></i>
        </div>
        <div
            class="rate-positive rate-action pointer shadow-small"
            (click)="rateGuide('positive')"
        >
            <i class="fa fa-thumbs-up"></i>
        </div>
    </div>
    } @if (showFeedback && !finishedRating) {
    <div class="rate-feedback">
        <ion-textarea
            placeholder="{{ lang.data['block.rate.feedback_placeholder'] }}"
            [(ngModel)]="feedback"
        ></ion-textarea>
        <ion-button
            class="button-gray"
            shape="round"
            expand="full"
            (click)="sendFeedback()"
        >
            {{ lang.data["block.rate.send_feedback"] }}
        </ion-button>
    </div>
    } @if (finishedRating) {
    <div class="confirm-feedback">
        {{ lang.data["feedback.confirmation"] }}
    </div>
    }
</div>
